import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import HookFormTextField from 'reservations/form/components/HookFormTextField';
import { useSubmitReservationDetails } from 'reservations/modify/hooks/useSumbitReservationDetails';

export const SpecialRequestModal = () => {
  const { note: existingNote } = useBookingDetails();
  const onClick = useSubmitReservationDetails();

  return (
    <BaseDrawer
      header="Share your special requests"
      subheader="Add a note to make your experience even more personalized."
      primaryButton={{ label: !!existingNote ? 'UPDATE' : 'SAVE', onClick }}
      requireAuth
    >
      <HookFormTextField
        multiline
        name="note"
        rows={2}
        placeholder="Special requests"
      />
    </BaseDrawer>
  );
};
